import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query';

import type { PracticeMemberUsageInput } from '../model/reporting.types';
import { reportingApi } from './reporting.api';

type PracticeMemberUsageListParams = Omit<PracticeMemberUsageInput, 'cursor' | 'asOf'>;

type PracticeMemberUsagePageParam = Pick<PracticeMemberUsageInput, 'cursor' | 'asOf'>;

export const practiceMemberUsageQueryKeys = {
    all: ['reporting', 'practice-member-usage'] as const,
    lists: () => [...practiceMemberUsageQueryKeys.all, 'list'] as const,
    list: (params: PracticeMemberUsageListParams) =>
        [...practiceMemberUsageQueryKeys.lists(), params] as const,
};

export function practiceMemberUsageInfiniteOptions(params: PracticeMemberUsageListParams) {
    return infiniteQueryOptions({
        queryKey: practiceMemberUsageQueryKeys.list(params),
        queryFn: ({ pageParam, signal }) => reportingApi.list({ ...params, ...pageParam }, signal),
        initialPageParam: {} as PracticeMemberUsagePageParam,
        // Page 1's snapshot time rides with every later cursor so the list stays stable while paging.
        getNextPageParam: (lastPage, allPages) =>
            lastPage.nextCursor
                ? { cursor: lastPage.nextCursor, asOf: allPages[0].asOf }
                : undefined,

        placeholderData: keepPreviousData,
    });
}
